'use client'
import {
  Countdown_default
} from "./chunk-CGCU6FO5.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/counter/Counter.tsx
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var Counter = ({ section }) => {
  var _a;
  const card = section.contentCollection.items[0];
  const links = (_a = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _a.items;
  if (!card) return null;
  return /* @__PURE__ */ jsxs(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_counter_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "gap-M flex w-full flex-col justify-between lg:flex-row lg:items-center", children: [
          /* @__PURE__ */ jsxs("div", { className: "gap-M flex items-center", children: [
            card.icon && /* @__PURE__ */ jsx(ContentfulMedia_default, { media: card.icon, className: "h-8 w-8" }),
            card.title && /* @__PURE__ */ jsxs("div", { className: "space-y-XXS", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "label-M", children: card.title }),
              card.subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body-S", color: "text-secondary", children: card.subtitle })
            ] })
          ] }),
          card.expiresAt && /* @__PURE__ */ jsx(Countdown_default, { finishDate: card.expiresAt, className: "mx-0 w-fit" })
        ] }),
        links == null ? void 0 : links.map((link) => /* @__PURE__ */ jsx(ContentfulButton_default, { link, className: "w-full sm:max-w-xs" }, link.id))
      ]
    }
  );
};
var Counter_default = Counter;

export {
  Counter_default
};
//# sourceMappingURL=chunk-GWKUENOB.mjs.map